<div id="content" class="main-content">
   <!-- ADD contact MESSAGES ############################################### -->
   <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
      id="contact_added" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
      position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
      <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
      <strong>Nouveau contact</strong> Ajouté avec succès. {{addedMsg}}
   </div>
   <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
      id="contact_not_added" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
      position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
      <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
      <strong>Ajout Echoué</strong>{{addError}}
   </div>
    <div class="container">
       <div class="col-12 pl-0">
          <div class="crumbs breadcrumbs-style-2">
             <ul class="breadcrumb">
                <li class="mt-3"><a href="dashboard" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                </li>
                <li class="mt-3"><a href="contacts" routerLink="/contacts">Contacts</a></li>
                <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Nouvel contact</a></li>
             </ul>
          </div>
       </div>
      <div class="page-header">
         <div class="page-title mt-3 row col-lg-12 col-md-12">
            <h2 style="color:black">Nouvel contact</h2>
         </div>
      </div>
      <form class="form-login" [formGroup]="newContactForm"  novalidate>
         <div class="layout-spacing">
            <div *ngIf="loadingAddingContact" class="cp-spinner cp-bubble  loading-spinner">
            </div>
            <div class="page-container01">
               <div class="page-container02">
                  <h3 class="page-text">
                     <span>Informations du contact</span>
                     <br />
                  </h3>
                  <div class="page-container03">

                     <div class="page-container04">
                        <div class="page-container05">
                           <!-- Propriétaire -->
                           <div class="page-container06">
                              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                 <input class="mdl-textfield__input " type="text" id="owner"name="owner" formControlName="owner" readonly>
                                 <label class="mdl-textfield__label" for="owner">Nom du propriétaire</label>
                             </div>
                           </div>
                           <!-- Civilité -->
                           <div class="page-container08">
                              <div class="page-container09">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <select class="mdl-textfield__input " id="civilite"
                                       name="civilite" formControlName="civilite">
                                       <option value="Mr">Mr</option>
                                       <option value="Mme">Mme</option>
                                       <option value="Mlle">Mlle</option>
                                    </select>
                                    <label class="mdl-textfield__label" for="civilite">Civilité <span style="color: red;"><b>*</b></span></label>
                                 </div>
                              </div>
                              <div *ngIf="newContactForm.get('civilite')?.hasError('required') && newContactForm.get('civilite')?.touched" class="error-message">
                                 La civilité est requise.
                              </div>
                           </div>
                        </div>
                        <div class="page-container10">
                           <!-- Prénom -->
                           <div class="page-container11">
                              <div class="page-container09">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="prenom" name="prenom" formControlName="prenom">
                                    <label class="mdl-textfield__label" for="prenom">Prénom <span style="color: red;"><b>*</b></span></label>
                                 </div>
                              </div>
                              <div *ngIf="newContactForm.get('prenom')?.hasError('required') && newContactForm.get('prenom')?.touched" class="error-message">
                                 Prénom est requis.
                              </div>
                           </div>
                           <!-- Nom -->
                           <div class="page-container13">
                              <div class="page-container14">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="nom" name="nom" formControlName="nom">
                                    <label class="mdl-textfield__label" for="nom">Nom <span style="color: red;"><b>*</b></span></label>
                                 </div>
                              </div>
                              <div *ngIf="newContactForm.get('nom')?.hasError('required') && newContactForm.get('nom')?.touched" class="error-message">
                                 Nom est requis.
                              </div>
                           </div>
                        </div> 
                     </div>

                     <div class="page-container15">
                        <div class="page-container16">
                           <!-- Nom du compte -->
                           <div class="page-container17">
                              <div class="page-container18">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input class="mdl-textfield__input " type="text" id="nomCompte" name="nomCompte" formControlName="nomCompte">
                                    <label class="mdl-textfield__label" for="nomCompte">Nom du compte</label>
                                 </div>
                              </div>
                           </div> 
                           <!-- Téléphone (domicile) -->
                           <div class="page-container19">
                              <div class="page-container20">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">   
                                    <input type="tel" maxlength="20" placeholder="Numéro marocain ou international (ex: 0612345678 / +212612345678)" class="mdl-textfield__input " id="telephoneDomicile" name="telephoneDomicile" formControlName="telephoneDomicile">
                                    <label class="mdl-textfield__label" for="telephoneDomicile">Téléphone (domicile)</label>
                                 </div>
                              </div>
                              <div *ngIf="newContactForm.get('telephoneDomicile')?.hasError('invalidPhoneNumber') && newContactForm.get('telephoneDomicile')?.touched" class="error-message">
                                 Le format du téléphone est invalide.
                              </div>
                           </div>
                        </div>
                        <div class="page-container21">
                           <!-- Téléphone (mobile) -->
                           <div class="page-container22">
                              <div class="page-container23">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="tel" maxlength="20" placeholder="Numéro marocain ou international (ex: 0612345678 / +212612345678)" class="mdl-textfield__input " id="telephoneMobile" name="telephoneMobile" formControlName="telephoneMobile">
                                    <label class="mdl-textfield__label" for="telephoneMobile">Téléphone (mobile)  <span style="color: red;"><b>*</b></span></label>
                                 </div>
                              </div>
                              <div *ngIf="newContactForm.get('telephoneMobile')?.hasError('required') && newContactForm.get('telephoneMobile')?.touched" class="error-message">
                                Téléphone (mobile) est requis.
                             </div>
                             <div *ngIf="newContactForm.get('telephoneMobile')?.hasError('invalidPhoneNumber') && newContactForm.get('telephoneMobile')?.touched" class="error-message">
                                Le format du téléphone est invalide.
                             </div>
                           </div>
                           <!-- Téléphone (autre) -->
                           <div class="page-container24">
                              <div class="page-container25">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="tel" maxlength="20" placeholder="Numéro marocain ou international (ex: 0612345678 / +212612345678)" class="mdl-textfield__input " id="telephoneAutre" name="telephoneAutre" formControlName="telephoneAutre">
                                    <label class="mdl-textfield__label" for="telephoneAutre">Téléphone (autre)</label>
                                 </div>
                              </div>
                                 <div *ngIf="newContactForm.get('telephoneAutre')?.hasError('invalidPhoneNumber') && newContactForm.get('telephoneAutre')?.touched" class="error-message">
                                    Le format du téléphone est invalide.
                                 </div>
                           </div>
                        </div>
                     </div>

                     <div class="page-container15">
                        <div class="page-container16">
                           <!-- Service du contact -->
                           <div class="page-container17">
                              <div class="page-container18">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="serviceContact" name="serviceContact" formControlName="serviceContact">
                                    <label class="mdl-textfield__label" for="serviceContact">Service du contact</label>
                                 </div>
                              </div>
                           </div>
                           <!-- Fonction du contact  -->
                           <div class="page-container19">
                              <div class="page-container20">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="fonctionContact" name="fonctionContact" formControlName="fonctionContact">
                                    <label class="mdl-textfield__label" for="fonctionContact">Fonction du contact</label>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="page-container21">
                           <!-- Adresse mail -->
                           <div class="page-container22">
                              <div class="page-container23">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="email" class="mdl-textfield__input " id="email" name="email" formControlName="email">
                                    <label class="mdl-textfield__label" for="email">Adresse e-mail <span style="color: red;"><b>*</b></span></label>
                                 </div>
                              </div>
                              <div *ngIf="newContactForm.get('email')?.hasError('required') && newContactForm.get('email')?.touched" class="error-message">
                                 L'adresse mail est requise.
                              </div>
                              <div *ngIf="newContactForm.get('email')?.hasError('email') && newContactForm.get('email')?.touched" class="error-message">
                                 Adresse e-mail invalide.
                              </div>
                           </div>
                           <!-- A quitter -->
                           <div class="page-container24" style="flex-direction: row-reverse">
                             
                           </div>
                        </div>
                     </div>   

                  </div>
               </div>
            </div>

            <div class="page-container01">
               <div class="page-container02">
                  <h3 class="page-text">
                     <span>Informations générales</span>
                     <br />
                  </h3>
                  <div class="page-container03">

                     <div class="page-container04">
                        <div class="page-container05">
                           <div class="page-container06">
                              <div class="page-container07">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="responsableHierarchique" name="responsableHierarchique" formControlName="responsableHierarchique">
                                    <label class="mdl-textfield__label" for="responsableHierarchique">Responsable hiérarchique</label>
                                 </div>
                              </div>
                           </div>
                           <div class="page-container08">
                              <div class="page-container09">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="originePiste" name="originePiste" formControlName="originePiste">
                                    <label class="mdl-textfield__label" for="originePiste">Origine de la piste</label>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="page-container10">
                           <div class="page-container11">
                              <div class="page-container12">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <select class="mdl-textfield__input " id="langue"
                                       name="langue" formControlName="langue">
                                       <option value="Arabe">Arabe</option>
                                       <option value="Français">Français</option>
                                       <option value="Anglais">Anglais</option>
                                       <option value="Italien">Italien</option>
                                       <option value="Autre">Autre</option>
                                    </select>                                    
                                    <label class="mdl-textfield__label" for="langue">Langue</label>
                                 </div>
                             </div>
                           </div>
                        </div> 
                     </div>

                     <div class="page-container49">
                        <div class="page-container50">
                          <div class="page-container51" style="flex-direction: row-reverse">
                           <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                              <input type="checkbox" class="mdl-textfield__input" id="garderContact" name="garderContact" formControlName="garderContact">
                              <label class="mdl-textfield__label checkLabel" for="garderContact">A garder</label>
                           </div>
                          </div>
                          <div class="page-container53">
                           <div class="page-container54" style="flex-direction: row-reverse">
                              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                 <input type="checkbox" class="mdl-textfield__input" id="quitterSociete" name="quitterSociete" formControlName="quitterSociete">
                                 <label class="mdl-textfield__label checkLabel" for="quitterSociete">A quitter la société</label>
                              </div>
                           </div>
                          </div>
                        </div>
                        <div class="page-container55">
                           <div class="page-container56" style="flex-direction: row-reverse">
                              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                 <input type="checkbox" class="mdl-textfield__input" id="invalideContact" name="invalideContact" formControlName="invalideContact">
                                 <label class="mdl-textfield__label checkLabel" for="invalideContact">Invalid contact</label>
                              </div>
                           </div>
                        </div>
                      </div>
                  </div>   
               </div>
            </div>

            <div class="page-container01">
               <div class="page-container02">
                  <h3 class="page-text">
                     <span>Adresses</span>
                     <br />
                  </h3>
                  <div class="page-container03">

                     <legend class="col-form-label-sm ml-3"><b>Adresse postale :</b></legend>
                     <div class="page-container04">
                        <div class="page-container05">
                           <!-- Rue -->
                           <div class="page-container06">
                              <div class="page-container07">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="adresseRue" name="adresseRue" formControlName="adresseRue">
                                    <label class="mdl-textfield__label" for="adresseRue">Rue</label>
                                 </div>
                              </div>
                           </div>
                           <!-- Code postale  -->
                           <div class="page-container08">
                              <div class="page-container09">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="codePostal" name="codePostal" formControlName="codePostal">
                                    <label class="mdl-textfield__label" for="codePostal">Code postale</label>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="page-container10">
                           <!-- Ville -->
                           <div class="page-container11">
                              <div class="page-container12">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="ville" name="ville" formControlName="ville">
                                    <label class="mdl-textfield__label" for="ville">Ville</label>
                                 </div>
                              </div>
                           </div>
                           <!-- Pays -->
                           <div class="page-container13">
                              <div class="page-container14">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="pays" name="pays" formControlName="pays">
                                    <label class="mdl-textfield__label" for="pays">Pays</label>
                                 </div>
                             </div>
                           </div>
                        </div> 
                     </div>

                     <legend class="col-form-label-sm ml-3"><b>Autre adresse :</b></legend>
                     <div class="page-container15">
                        <div class="page-container16">
                           <div class="page-container17">
                              <div class="page-container18">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="autreAdresseRue" name="autreAdresseRue" formControlName="autreAdresseRue">
                                    <label class="mdl-textfield__label" for="autreAdresseRue">Rue (Autre)</label>
                                 </div>
                              </div>
                           </div>
                           <div class="page-container19">
                              <div class="page-container20">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="autreCodePostal" name="autreCodePostal" formControlName="autreCodePostal">
                                    <label class="mdl-textfield__label" for="autreCodePostal">Code postale (Autre)</label>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="page-container21">
                           <div class="page-container22">
                              <div class="page-container23">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="autreVille" name="autreVille" formControlName="autreVille">
                                    <label class="mdl-textfield__label" for="autreVille">Ville (Autre)</label>
                                 </div>
                              </div>
                           </div>
                           <div class="page-container24">
                              <div class="page-container25">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <input type="text" class="mdl-textfield__input " id="autrePays" name="autrePays" formControlName="autrePays">
                                    <label class="mdl-textfield__label" for="autrePays">Pays (Autre)</label>
                                 </div>  
                              </div>
                           </div>
                        </div>
                     </div>                        
                  </div>
               </div>
            </div>

            <div class="page-container01">
               <div class="page-container02">
                  <h3 class="page-text">
                     <span>Description</span>
                     <br />
                  </h3>
                  <div class="page-container03">
                     <div class="page-container60">
                        <div class="page-container61">
                           <div class="page-container62">
                              <div class="page-container63">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label"  style="min-width: 100%!important;">
                                    <textarea class="mdl-textfield__input" id="description" name="description" formControlName="description"></textarea>
                                    <label class="mdl-textfield__label" for="description">Description</label>
                                 </div>
                              </div>
                           </div>
                        </div>
                      </div>                        
                  </div>
               </div>
            </div>
            
            <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing mt-3">
               <div class="l-a-load-more pt-2 actions_buttons d-flex justify-content-center">
                  <button class="btn progress-button btn-rounded mb-2 pr-5 pl-5 mr-2" style="background-color: #bac5ed;" routerLink="/contacts">
                     Retour
                  </button>
                  <button id="loading-circle-notification" class="btn btn-gradient-dark btn-rounded mb-2 mr-2 pr-5 pl-5"
                  (click)="saveAndReset()" [disabled]="newContactForm.invalid">Enregistrer et Nouveau</button>
                  <button class="btn btn-gradient-success btn-rounded mb-2 pr-5 pl-5 mr-2"
                  (click)="save()" [disabled]="newContactForm.invalid">Enregistrer</button>
                  </div>
            </div>
         </div>
      </form>
    </div>
 </div>